import { Route, Routes } from 'react-router';

import Layout from '@/components/templates/Layout';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';

import { ContactDetailPage } from './pages/ContactDetailPage';
import { ContactsListPage } from './pages/ContactsListPage';
import { DebtsPage } from './pages/DebtsPage';

export const ContactsRouter = () => {
  return (
    <Layout>
      <PermissionsWrapper module="contacts">
        <Routes>
          <Route index element={<ContactsListPage />} />
          <Route path=":contactId" element={<ContactDetailPage />} />
          <Route path=":contactId/:tab" element={<ContactDetailPage />} />
        </Routes>
      </PermissionsWrapper>
    </Layout>
  );
};

export const DebtsRouter = () => {
  return (
    <Layout>
      <PermissionsWrapper module="contacts">
        <DebtsPage />
      </PermissionsWrapper>
    </Layout>
  );
};
